<template>
    <div v-if="inputVal">
        <student-worksheet-module-wrapper
            :module="module"
            :module-complete="response.module_complete"
            :worksheet-complete="worksheetComplete"
        >
            <div class="px-8">
                <div class="my-4 flex flex-col gap-4">
                    <div v-for="(choice, index) in possibleChoices">
                        <span
                            :class="
                                'block w-full !whitespace-normal rounded border border-gray-325 p-4 text-gray-825 hover:cursor-pointer hover:bg-gray-325/20 ' +
                                (isSelected(choice)
                                    ? choice.is_correct
                                        ? 'border-[2px] border-green-500'
                                        : 'border-[2px] border-red-400'
                                    : 'border-gray-325')
                            "
                            @click="toggleChoice(choice)"
                        >
                            {{ choice.text }}</span
                        >
                    </div>
                </div>
            </div>
        </student-worksheet-module-wrapper>
    </div>
</template>

<script>
import { trim } from "lodash";
import StudentWorksheetModuleWrapper from "./StudentWorksheetModuleWrapper";
import StudentQuizQuestionAnswer from "@/Components/StudentQuizQuestionAnswer.vue";

export default {
    name: "StudentWorksheetModuleChoice",
    components: {
        StudentQuizQuestionAnswer,
        StudentWorksheetModuleWrapper,
    },
    props: ["modelValue", "module", "worksheetComplete"],
    data() {
        return {
            response: {},
            possibleChoices: [],
        };
    },
    created() {
        this.module.content.choices.map(function (choice) {
            choice.text = trim(choice.text);
        });

        this.possibleChoices = _.shuffle(this.module.content.choices);

        if (this.modelValue) {
            this.response = {
                choices: this.modelValue.choices,
                module_complete: this.modelValue.module_complete,
            };
        } else {
            this.response = {
                choices: [],
                module_complete: false,
            };
        }

        this.inputVal = this.response;
    },
    methods: {
        toggleChoice(choice) {
            let vm = this;

            if (vm.inputVal.module_complete) {
                return;
            }
            if (vm.module.type === "choice_many") {
                let includes = false;
                let index = -1;
                for (let responseChoice of vm.response.choices) {
                    index++;
                    if (responseChoice.text === choice.text) {
                        includes = true;
                        break;
                    }
                }

                if (includes) {
                    vm.response.choices.splice(index, 1);
                } else {
                    vm.response.choices.push(choice);
                }
            } else {
                vm.response.choices = [choice];
            }

            this.$emit("update:modelValue", vm.response);

            vm.checkAnswer();
        },
        isSelected(choiceToCheck) {
            let selected = false;
            let vm = this;
            this.response.choices.forEach(function (choice) {
                if (choice.text === choiceToCheck.text) {
                    selected = true;
                }
                if (
                    vm.response &&
                    vm.response.module_complete &&
                    !choice.is_correct
                ) {
                    selected = false;
                }
            });

            return selected;
        },
        checkAnswer: function () {
            let vm = this;
            let possibleCorrect = 0;
            let studentCorrect = 0;
            let studentWrong = 0;

            vm.module.content.choices.forEach(function (choice) {
                if (choice.is_correct) {
                    possibleCorrect++;
                }
            });

            vm.response.choices.forEach(function (choice) {
                if (choice.is_correct) {
                    studentCorrect++;
                } else {
                    studentWrong++;
                }
            });

            if (studentWrong === 0) {
                vm.response.module_complete =
                    possibleCorrect >= 1 && possibleCorrect === studentCorrect;
            }

            if (vm.response.module_complete) {
                this.$emit("update:modelValue", vm.response);
            }
        },
    },
};
</script>

<style scoped></style>
